// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout-module--Layout--1mFQg","Content":"Layout-module--Content--UnRdd"};